// Bộ STICKER nội bộ — "sticker thẻ chữ": emoji cỡ lớn + câu tiếng Việt trên nền màu bo tròn.
// Tự vẽ 100% (không dùng ảnh bản quyền, không tải tài nguyên ngoài) nên nhẹ, chạy offline, đủ dấu.
// Tin sticker chỉ lưu ID (vd 'cs_ok'); client tra bảng này để vẽ -> đổi/thêm sticker không đụng dữ liệu cũ.

export const STICKER_PACKS = [
  {
    key: 'congso',
    label: '💼',
    name: 'Công sở',
    items: [
      { id: 'cs_ok', emoji: '👍', text: 'Ok bạn ơi', bg: 'linear-gradient(135deg,#6366f1,#8b5cf6)' },
      { id: 'cs_done', emoji: '✅', text: 'Đã xong!', bg: 'linear-gradient(135deg,#10b981,#059669)' },
      { id: 'cs_busy', emoji: '😵‍💫', text: 'Đang bận xíu', bg: 'linear-gradient(135deg,#f59e0b,#f97316)' },
      { id: 'cs_meeting', emoji: '📢', text: 'Vào họp thôi', bg: 'linear-gradient(135deg,#0ea5e9,#2563eb)' },
      { id: 'cs_deadline', emoji: '⏰', text: 'Sắp trễ deadline', bg: 'linear-gradient(135deg,#ef4444,#dc2626)' },
      { id: 'cs_coffee', emoji: '☕', text: 'Nghỉ cà phê', bg: 'linear-gradient(135deg,#a16207,#78350f)' },
      { id: 'cs_good', emoji: '💯', text: 'Làm tốt lắm', bg: 'linear-gradient(135deg,#22c55e,#16a34a)' },
      { id: 'cs_thanks', emoji: '🙏', text: 'Cảm ơn nhé', bg: 'linear-gradient(135deg,#ec4899,#db2777)' },
    ],
  },
  {
    key: 'camxuc',
    label: '😆',
    name: 'Cảm xúc',
    items: [
      { id: 'em_haha', emoji: '🤣', text: 'Hahaha', bg: 'linear-gradient(135deg,#f59e0b,#f97316)' },
      { id: 'em_love', emoji: '🥰', text: 'Thương thương', bg: 'linear-gradient(135deg,#fb7185,#e11d48)' },
      { id: 'em_cry', emoji: '😭', text: 'Huhu', bg: 'linear-gradient(135deg,#38bdf8,#0284c7)' },
      { id: 'em_shock', emoji: '😱', text: 'Trời ơi', bg: 'linear-gradient(135deg,#a78bfa,#7c3aed)' },
      { id: 'em_angry', emoji: '😤', text: 'Tức ghê', bg: 'linear-gradient(135deg,#f87171,#b91c1c)' },
      { id: 'em_cool', emoji: '😎', text: 'Đỉnh của chóp', bg: 'linear-gradient(135deg,#334155,#0f172a)' },
      { id: 'em_shy', emoji: '😳', text: 'Ngại quá', bg: 'linear-gradient(135deg,#f9a8d4,#ec4899)' },
      { id: 'em_sleep', emoji: '😴', text: 'Buồn ngủ', bg: 'linear-gradient(135deg,#818cf8,#4f46e5)' },
    ],
  },
  {
    key: 'dongvien',
    label: '💪',
    name: 'Động viên',
    items: [
      { id: 'dv_fighting', emoji: '💪', text: 'Cố lên!', bg: 'linear-gradient(135deg,#f97316,#ea580c)' },
      { id: 'dv_win', emoji: '🏆', text: 'Số một', bg: 'linear-gradient(135deg,#eab308,#ca8a04)' },
      { id: 'dv_fire', emoji: '🔥', text: 'Cháy hết mình', bg: 'linear-gradient(135deg,#ef4444,#f97316)' },
      { id: 'dv_clap', emoji: '👏', text: 'Hoan hô', bg: 'linear-gradient(135deg,#14b8a6,#0d9488)' },
      { id: 'dv_star', emoji: '🌟', text: 'Tuyệt vời', bg: 'linear-gradient(135deg,#8b5cf6,#6d28d9)' },
      { id: 'dv_hi5', emoji: '🙌', text: 'Quá đỉnh', bg: 'linear-gradient(135deg,#06b6d4,#0891b2)' },
    ],
  },
  {
    key: 'chaohoi',
    label: '👋',
    name: 'Chào hỏi',
    items: [
      { id: 'ch_hi', emoji: '👋', text: 'Xin chào', bg: 'linear-gradient(135deg,#0ea5e9,#6366f1)' },
      { id: 'ch_morning', emoji: '☀️', text: 'Chào buổi sáng', bg: 'linear-gradient(135deg,#fbbf24,#f59e0b)' },
      { id: 'ch_bye', emoji: '🫡', text: 'Chào nhé', bg: 'linear-gradient(135deg,#64748b,#334155)' },
      { id: 'ch_night', emoji: '🌙', text: 'Ngủ ngon', bg: 'linear-gradient(135deg,#4338ca,#312e81)' },
      { id: 'ch_yes', emoji: '🆗', text: 'Được luôn', bg: 'linear-gradient(135deg,#22c55e,#15803d)' },
      { id: 'ch_no', emoji: '🙅', text: 'Thôi khỏi', bg: 'linear-gradient(135deg,#fb7185,#be123c)' },
    ],
  },
];

// Bảng tra nhanh theo id.
const STICKER_MAP = {};
for (const p of STICKER_PACKS) for (const s of p.items) STICKER_MAP[s.id] = s;

export const getSticker = (id) => STICKER_MAP[id] || null;
export const isSticker = (id) => !!STICKER_MAP[id];

// Thẻ sticker render trong đoạn chat / bảng chọn. size='sm' cho lưới chọn.
export function Sticker({ id, size }) {
  const s = getSticker(id);
  if (!s) return <div className="sticker-card sticker-unknown">Sticker</div>;
  return (
    <div className={'sticker-card' + (size === 'sm' ? ' sm' : '')} style={{ background: s.bg }} title={s.text}>
      <span className="sticker-emoji">{s.emoji}</span>
      <span className="sticker-text">{s.text}</span>
    </div>
  );
}
